import {Routes} from '@angular/router';
import {MsalGuard} from "@azure/msal-angular";

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./components/main/main'),
        canActivate: [MsalGuard],
    }
];
